(function iife() {
	"use strict";

	angular.module("dx.webapp.node").directive("dxNodeCreateEdit", nodeCreateEditDirective);

	function nodeCreateEditDirective() {
		return {
			restrict: "E",
			templateUrl: "tmpl/node/node-create-edit-directive.html",
			scope: {
				node: "=",
				saveCallback: "=?",
				unsavedChanges: "=",
			},
			controllerAs: "vm",
			controller: "dxNodeCreateEditController",
		};
	}
}());
